module.exports = __webpack_public_path__ + "static/Cloudstack_mono-54c03fefa0f83cc63dae62b94a171682.svg";